import classNames from 'classnames';
import EcoIconClose from 'eco-design-micro/icons/eco-icon-close';
import React, { useEffect, useRef } from 'react';
import './index.scss';

export interface EcoDialogProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 弹窗大小
     */
    size?: 'large' | 'middle' | 'small';
    /**
     * 标题
     */
    title?: string;
    /**
     * 副标题
     */
    subTitle?: string;
    /**
     * 是否开启弹窗
     */
    open: boolean;
    /**
     * 自定义脚部
     */
    footer?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 启用模态框
     */
    isModal?: boolean;
    onClick?: (event: MouseEvent) => void;
    onOk?: () => void;
    onCancel?: () => void;
    /**
     * 内容
     */
    children?: React.ReactNode;
}

/**
 * 基于dialog实现的弹窗
 */
export default function EcoDialog({
    theme = 'white',
    title,
    subTitle,
    open = false,
    isModal = true,
    className,
    size = 'middle',
    onCancel,
    children,
}: EcoDialogProps) {
    const prefixCls = 'eco-dialog';
    const compCls = classNames(`${prefixCls}-root`, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-size-${size}`]: size,
        [`${prefixCls}-no-modal`]: !isModal,
    });
    const refDialog = useRef<HTMLDialogElement>(null);
    // 点击关闭
    const cancelHandle = () => {
        closeDialogHandle();
        if (onCancel) {
            onCancel();
        }
    };
    // 执行关闭
    const closeDialogHandle = () => {
        if (refDialog.current) {
            refDialog.current.close();
        }
    };
    useEffect(() => {
        if (open && refDialog.current && isModal) {
            refDialog.current.showModal();
        } else if (open && refDialog.current) {
            refDialog.current.show();
        }
    }, [open]);
    return (
        <dialog className={compCls} ref={refDialog}>
            <div className={`${prefixCls}-wrap`}>
                <div className={`${prefixCls}-content`}>
                    <div className={`${prefixCls}-header`}>
                        {title && <div className={`${prefixCls}-title`}>{title}</div>}
                        {subTitle && <div className={`${prefixCls}-subTitle`}>{subTitle}</div>}
                    </div>
                    <div className={`${prefixCls}-body`}>{children}</div>
                    <button className={`${prefixCls}-close`} onClick={cancelHandle}>
                        <EcoIconClose />
                    </button>
                </div>
            </div>
        </dialog>
    );
}
